




















































































































































































































































































import {
  computed,
  defineComponent,
  nextTick,
  PropType,
  ref,
} from '@nuxtjs/composition-api';
import { Job, BookmarkType } from '@/graphql/graphqlOperations';
import useAppRoute from '~/compositions/useAppRoute';
export default defineComponent({
  props: {
    job: {
      type: Object as PropType<Job>,
      required: true,
    },
    showBookmark: {
      type: Boolean,
      default: false,
    },
    isPickup: {
      type: Boolean,
      default: false,
    },
    isLinkToPlanPage: {
      type: Boolean,
      default: true,
    },
  },
  /**
   * @param props
   */
  setup(props) {
    const { URLs } = useAppRoute();
    const bookmark = ref(props.job.bookmark);
    const imageUrl = computed(() => {
      return (
        props.job.plusImage3Url ||
        props.job.plusImage2Url ||
        props.job.plusImage1Url ||
        props.job.coverImageUrl
      );
    });

    // iframeのtitle属性
    const title = computed(
      () => `${props.job.listVideo?.videoType}:${props.job.listVideo?.videoId}`
    );

    const getAdoptionText = (
      type: string,
      proved: boolean,
      scheduled: boolean
    ) => {
      if (proved === false && scheduled === false) {
        return;
      }

      let text = type === 'handicap' ? '障がい者採用' : '留学生採用';
      if (proved === true && scheduled === true) {
        text += '実績・予定あり';
      }
      if (proved === true && scheduled === false) {
        text += '実績あり';
      }
      if (proved === false && scheduled === true) {
        text += '予定あり';
      }
      return text;
    };

    const getIndustriesText = () => {
      const list = [];
      if (props.job.corporation.category1) {
        list.push(props.job.corporation.category1.label);
      }
      if (props.job.corporation.category2) {
        list.push(props.job.corporation.category2.label);
      }
      if (props.job.corporation.category3) {
        list.push(props.job.corporation.category3.label);
      }

      if (list.length === 0) {
        return '';
      }
      return list.join(' / ');
    };

    return {
      URLs,
      BookmarkType,
      bookmark,
      imageUrl,
      title,
      getAdoptionText,
      getIndustriesText,
    };
  },
});
